import React, { Component } from 'react';
import Table from "../../Tables/SäljareTabell";
import moment from "moment"

export default class Säljare extends Component {
    render() {
        return (
            <div style={{ color: 'white' }}>
            {/* <div className="text-center" style={{ color: 'white' }}> */}
                <div>
                    {
                        this.props.DsfontSize === 12 ?
                        <h2 style={{ paddingTop: '12px', color: '#44D1C2', paddingLeft: '16px', marginBottom: '5px' }}><b>{moment(new Date).format("YYYY-MM-DD")}</b></h2>
                       : <h2 style={{ paddingTop: '12px', color: '#44D1C2', paddingLeft: '16px', marginBottom: '0px' }}><b>{moment(new Date).format("YYYY-MM-DD")}</b></h2>
                    }

                </div>
                <div className="d-flex justify-content-center" style={{width: '100%'}} >
                {/* <div className="d-flex justify-content-center" maxHeight={this.props.maxHeight} style={{maxHeight: this.props.DSMaxHeight}}> */}
                    <Table DSMaxHeight={this.props.DSMaxHeight} DsfontSize={this.props.DsfontSize} Afid={this.props.Afid} Kontor={this.props.Kontor}/>
                </div>
            </div>
        )
    }
}
